import 'react-app-polyfill/stable'
import '@fontsource/noto-sans-jp'
import 'core-js'
import React from 'react'
import { createRoot } from 'react-dom/client'
import reportWebVitals from './reportWebVitals'
import { Provider } from 'react-redux'
import { persistor, store } from './redux/store/store'
import { PersistGate } from 'redux-persist/integration/react'
import App from './App'
import './configs/i18n'

createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>,
)

reportWebVitals()
